/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface EntityLockTokenInputDto
 */
export interface EntityLockTokenInputDto {
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenInputDto
     */
    entityType: string;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenInputDto
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenInputDto
     */
    $type?: EntityLockTokenInputDtoTypeEnum;
}


/**
 * @export
 */
export const EntityLockTokenInputDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoEntityLockTokensEntityLockTokenInputDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.EntityLockTokens.EntityLockTokenInputDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EntityLockTokenInputDtoTypeEnum = typeof EntityLockTokenInputDtoTypeEnum[keyof typeof EntityLockTokenInputDtoTypeEnum];


/**
 * Check if a given object implements the EntityLockTokenInputDto interface.
 */
export function instanceOfEntityLockTokenInputDto(value?: unknown): value is EntityLockTokenInputDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EntityLockTokenInputDtoTypeEnum)[0];
}

export function EntityLockTokenInputDtoFromJSON(json: any): EntityLockTokenInputDto {
    return EntityLockTokenInputDtoFromJSONTyped(json, false);
}

export function EntityLockTokenInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityLockTokenInputDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityType': json['entityType'],
        'entityId': json['entityId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EntityLockTokenInputDtoToJSON(value?: EntityLockTokenInputDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'entityType': value.entityType,
        'entityId': value.entityId,
        '$type': value.$type,
    });
}

